// Single source of truth for PostHog feature-flag keys. The string values are
// what PostHog sees — add new entries here and reference them everywhere
// else via `FLAGS.<name>` so there's exactly one place to rename a flag.
export const FLAGS = {
  translations: "translations",
  mapExport: "map-export",
  stencilOverlay: "stencil-overlay",
  bplanMetrics: "bplan-metrics",
  exclusionSubtypes: "exclusion-subtypes",
  // Gates the reworked canvas-editor layout: the zone-type selector and
  // GRZ/GFZ move from the right-hand Inspector into the Brief panel, and the
  // Inspector is hidden (its "see all metrics" drawer button moves into the
  // Brief). Off = today's Inspector-based layout.
  briefRedesign: "brief-redesign",
  summaryPdf: "summary-pdf",
  exportPaywall: "export-paywall",
  // Gates /admin/tessellation-steps — admin diagnostic that walks the
  // aggregator pipeline stage-by-stage and exposes the Daiwa typology
  // footprints. Hidden from production while the work is in progress.
  tessellationSteps: "tessellation-steps",
  // Gates /projects/:id/studio — the wizard (Brief → Explore → Finalize)
  // flow, bound to the real Editor so generation is real.
  designStudio: "design-studio",
  // Studio Finalize: show the paid report tiers (real Stripe payment links).
  reportPaymentLink: "report-payment-link",
  // Studio Finalize: show the free "set export view & download" preview buttons
  // (the report PDF without paying — for testing).
  reportPreview: "report-preview",
  // OG export wizard: offer a Stripe hosted payment link alongside the in-app
  // card flow (card stays for sim testing; the link is the real-money path).
  exportPaymentLink: "export-payment-link",
  // Shows the Admin nav link (internal diagnostics/ingestion area).
  admin: "admin",
} as const;

export type FlagName = (typeof FLAGS)[keyof typeof FLAGS];
